import React from "react";
import { Link } from "react-router-dom";
import { classNames } from "../../helpers";

const Button = ({
  buttonClasses,
  type = "primary", //"primary"||"secondary"
  buttonType = "button",
  buttonIcon,
  buttonIconPosition,
  buttonLabel,
  buttonLabelClasses,
  buttonFunction,
  buttonHasLink,
  buttonLink,
  target,
  functions,
  disabled = false,
  loading = false,
  effect = false,
  ...props
}) => {
  return (
    <>
      {buttonHasLink ? (
        <Link
          to={buttonLink}
          target={target}
          className={classNames(
            "flex justify-center items-center gap-2 rounded-full text-lg h-10 py-0 px-3 transition-all duration-200 text-black border border-transparent",
            type === "primary"
              ? "bg-gametime-green !border-gametime-green"
              : "bg-transparent !border-black",
            buttonClasses
          )}
        >
          {buttonIconPosition === "left" && (
            <i className={"fa-fw " + buttonIcon}></i>
          )}
          {buttonLabel && (
            <span className={"text-sm font-medium " + buttonLabelClasses}>
              {buttonLabel}
            </span>
          )}
          {buttonIconPosition === "right" && (
            <i className={"fa-fw " + buttonIcon}></i>
          )}
        </Link>
      ) : (
        <button
          type={buttonType}
          className={classNames(
            "relative z-0 overflow-hidden flex justify-center items-center gap-2 rounded-full text-lg h-10 py-0 px-3 transition-all duration-200 text-black border border-transparent bg-transparent after:absolute after:h-full",
            effect
              ? "after:content-[''] after:-z-[1] after:top-0 after:left-0 after:bg-gametime-green after:transition-[width] after:duration-300 after:ease-in-out"
              : "",
            type === "primary"
              ? `border-gametime-green after:w-full ${
                  effect ? "hover:after:w-0 hover:border-black" : "!bg-gametime-green"
                }`
              : `border-black after:w-0 ${
                  effect ? "hover:after:w-full hover:border-gametime-green" : ""
                }`,
            disabled ? "!opacity-70 cursor-not-allowed" : "",
            buttonClasses
          )}
          onClick={buttonFunction}
          disabled={disabled}
        >
          {buttonIconPosition === "left" && (
            <i
              className={classNames(
                "fa-fw ",
                loading
                  ? "fa-duotone fa-solid fa-spinner-third animate-spin"
                  : buttonIcon
              )}
            ></i>
          )}
          {buttonLabel && (
            <span className={"text-sm font-medium " + buttonLabelClasses}>
              {buttonLabel}
            </span>
          )}
          {buttonIconPosition === "right" && (
            <i
              className={classNames(
                "fa-fw ",
                loading
                  ? "fa-duotone fa-solid fa-spinner-third animate-spin"
                  : buttonIcon
              )}
            ></i>
          )}
        </button>
      )}
    </>
  );
};

export default Button;
